import { createContext, useReducer, } from 'react';

export const AppContext = createContext();

const authInitialState = {
    user: null,
    authIsReady: false,
};

const newFolderModalInitialState = {
    newFolderModalIsOpen: false,
}

const initialState = {
    ...authInitialState,
    ...newFolderModalInitialState,
};

export const appReducer = (state, action) => {
    switch (action.type) {
        case 'AUTH-USER/AUTH':
            return {
                ...state,
                user: action.payload,
                authIsReady: true,
            };

        case 'AUTH-USER/LOGIN':
            return {
                ...state,
                user: action.payload,
            };

        case 'AUTH-USER/LOGOUT':
            return {
                ...state,
                user: null,
            };

        case 'NEW-FOLDER-MODAL/OPEN':
            return {
                ...state,
                newFolderModalIsOpen: true,
            };

        case 'NEW-FOLDER-MODAL/CLOSE':
            return {
                ...state,
                newFolderModalIsOpen: false,
            };

        default:
            return state;
    }
};

export const AppContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    const actions = {
        authUser(user) {
            dispatch({ type: 'AUTH-USER/AUTH', payload: user, });
        },
        loginUser(user) {
            dispatch({ type: 'AUTH-USER/LOGIN', payload: user, });
        },
        logoutUser() {
            dispatch({ type: 'AUTH-USER/LOGOUT', });
        },
        newFolderModalOpen() {
            dispatch({ type: 'NEW-FOLDER-MODAL/OPEN', });
        },
        newFolderModalClose() {
            dispatch({ type: 'NEW-FOLDER-MODAL/CLOSE', });
        },
    };

    return (
        <AppContext.Provider value={{...state, ...actions}}>
            { children }
        </AppContext.Provider>
    );
}